<template>
  <PrePeersLegalDocument
    :title="t('legalPages.privacyPolicy.pageTitle')"
    :highlighted-title-part="t('legalPages.privacyPolicy.highlightedTitlePart')"
    :version-label="t('legalPages.privacyPolicy.versionLabel')"
    :html="privacyPolicyHtml" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import privacyPolicyHtml from '~/assets/legal/politique-de-confidentialite.html?raw'
import PrePeersLegalDocument from '~/components/sections/PrePeersLegalDocument.vue'

const { t } = useI18n()

definePageMeta({
  layout: 'default',
})

useSeoMeta({
  title: computed(() => t('legalPages.privacyPolicy.metaTitle')),
  description: computed(() => t('legalPages.privacyPolicy.metaDescription')),
  ogTitle: computed(() => t('legalPages.privacyPolicy.metaTitle')),
  ogDescription: computed(() => t('legalPages.privacyPolicy.metaDescription')),
})
</script>
